import { jsx as J } from "react/jsx-runtime";
import { useRef as C, useEffect as q, useMemo as j, forwardRef as K, useState as W, useCallback as s } from "react";
import { MultipleSelectWithOptionList as Q, Mode as X } from "../../../filters/addFilterPanel/MultipleSelectWithOptionList.js";
function Y(e, c, l) {
  var E = this, d = C(null), y = C(0), a = C(null), u = C([]), S = C(), w = C(), p = C(e), i = C(!0);
  p.current = e;
  var x = typeof window < "u", O = !c && c !== 0 && x;
  if (typeof e != "function") throw new TypeError("Expected a function");
  c = +c || 0;
  var F = !!(l = l || {}).leading, I = !("trailing" in l) || !!l.trailing, h = "maxWait" in l, z = "debounceOnServer" in l && !!l.debounceOnServer, L = h ? Math.max(+l.maxWait || 0, c) : null;
  q(function() {
    return i.current = !0, function() {
      i.current = !1;
    };
  }, []);
  var N = j(function() {
    var V = function(r) {
      var t = u.current, T = S.current;
      return u.current = S.current = null, y.current = r, w.current = p.current.apply(T, t);
    }, A = function(r, t) {
      O && cancelAnimationFrame(a.current), a.current = O ? requestAnimationFrame(r) : setTimeout(r, t);
    }, b = function(r) {
      if (!i.current) return !1;
      var t = r - d.current;
      return !d.current || t >= c || t < 0 || h && r - y.current >= L;
    }, P = function(r) {
      return a.current = null, I && u.current ? V(r) : (u.current = S.current = null, w.current);
    }, g = function r() {
      var t = Date.now();
      if (b(t)) return P(t);
      if (i.current) {
        var T = c - (t - d.current), R = h ? Math.min(T, L - (t - y.current)) : T;
        A(r, R);
      }
    }, M = function() {
      if (x || z) {
        var r = Date.now(), t = b(r);
        if (u.current = [].slice.call(arguments), S.current = E, d.current = r, t) {
          if (!a.current && i.current) return y.current = d.current, A(g, c), F ? V(d.current) : w.current;
          if (h) return A(g, c), V(d.current);
        }
        return a.current || A(g, c), w.current;
      }
    };
    return M.cancel = function() {
      a.current && (O ? cancelAnimationFrame(a.current) : clearTimeout(a.current)), y.current = 0, u.current = d.current = S.current = a.current = null;
    }, M.isPending = function() {
      return !!a.current;
    }, M.flush = function() {
      return a.current ? P(Date.now()) : w.current;
    }, M;
  }, [F, h, c, L, I, O, x, z]);
  return N;
}
const ee = K(({
  filter: e,
  handleFilterChange: c,
  withBackground: l,
  getPopupContainer: E,
  onApply: d,
  onFocus: y,
  onBlur: a,
  loadDictionaryEntries: u
}, S) => {
  const [w, p] = W(!1), [i, x] = W([]), [O, F] = W([]), [I, h] = W(""), [z, L] = W(!1), [N, V] = W();
  q(() => {
    V("");
  }, [z]);
  const A = s(() => {
    e.reference && e.reference.dictionaryCode && (p(!0), u(e.reference.dictionaryCode, void 0, {
      offset: 0,
      pageSize: 20
    }).then((n) => {
      F(n), h(e.reference.dictionaryCode), p(!1);
    }).catch(() => p(!1)));
  }, [e.reference, u]);
  q(() => {
    x(O.map((n) => ({
      label: n.value,
      value: n.value,
      selected: !!e.predicate.value.entries.find((o) => o.id === n.value)
    })));
  }, [O, e]), q(() => {
    e.reference && e.reference.code && I !== e.reference.dictionaryCode && A();
  }, [e.reference, I, A]);
  const b = s((n) => {
    c({
      ...e,
      predicate: {
        ...e.predicate,
        value: {
          ...e.predicate.value,
          entries: n
        }
      },
      isValid: !0
    });
  }, [e, c]), P = s(() => {
    d({
      ...e,
      predicate: {
        ...e.predicate,
        value: {
          ...e.predicate.value,
          entries: e.predicate.value.entries.map((n) => ({
            id: n.id
          }))
        }
      },
      isValid: !0
    }), V("");
  }, [e, d]), g = s((n, o) => {
    const f = n.filter((m) => m.selected).map((m) => ({
      id: m.value,
      value: m.value
    }));
    x(n);
    const v = [...o.filter((m) => !n.find((H) => H.value === m.id)), ...f];
    b(v.map((m) => ({
      id: m.id
    })));
  }, [b]), M = s((n, o) => {
    const f = Array.from(i), v = f.findIndex((m) => m.value === n.value);
    f[v] = {
      ...f[v],
      selected: o
    }, g(f, e.predicate.value.entries);
  }, [i, e.predicate.value.entries, g]), r = s((n) => {
    const o = Array.from(i).map((v) => ({
      ...v,
      selected: n.includes(v.value)
    })), f = n.map((v) => ({
      id: v,
      value: v
    }));
    g(o, f);
  }, [i, g]), t = j(() => e.predicate.value.entries.map((n) => n.id), [e]), T = s((n) => {
    e.reference && e.reference.dictionaryCode && u(e.reference.dictionaryCode, N, n).then(
      (o) => {
        F((f) => [...f, ...o]), h(e.reference.dictionaryCode), p(!1);
      }
    ).catch(() => p(!1));
  }, [e.reference, u, N]), R = s((n) => {
    e.reference && e.reference.dictionaryCode && u(e.reference.dictionaryCode, n, {
      offset: 0,
      pageSize: 20
    }).then(
      (o) => {
        F(o), h(e.reference.dictionaryCode), p(!1);
      }
    ).catch(() => p(!1));
  }, [e.reference, u]), U = Y(R, 500), k = s((n) => {
    e.reference && (V(n), U(n));
  }, [e.reference, U]), B = s(() => {
    if (e.predicate.value.entries.length > 0) {
      const n = i.map((o) => ({
        ...o,
        selected: !1
      }));
      x(n), b([]);
    }
  }, [i, e.predicate.value.entries.length, b]), D = s((n) => {
    L(n);
  }, []), G = s(() => {
    a({
      ...e,
      predicate: {
        ...e.predicate,
        value: {
          ...e.predicate.value,
          entries: e.predicate.value.entries.map((n) => ({
            id: n.id
          }))
        }
      },
      isValid: !0
    });
  }, [e, a]);
  return /* @__PURE__ */ J(
    Q,
    {
      ref: S,
      getPopupContainer: E,
      mode: X.MULTIPLE,
      size: "small",
      isSimpleInput: !0,
      withBackground: l,
      onApply: P,
      value: t,
      placement: "rightTop",
      options: i,
      loading: w,
      onChange: M,
      onSelectionChange: r,
      onClear: B,
      onVisibilityChange: D,
      onPaginationChange: T,
      onFocus: y,
      onBlur: G,
      onSearch: k
    }
  );
});
export {
  ee as default
};
//# sourceMappingURL=FilterValueMatch.js.map
